// extracted by mini-css-extract-plugin
export default {"container":"appStyle_container__mAmIR"};